import firebase from 'firebase/app';
import React, { useState, useEffect } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { useBooleanState } from '../utils/react/use_boolean_state';
import { Header } from './Header';
import { LoginPage } from './Login';
import { MyPage } from './MyPage';
import { Board } from './Board';
import { Names } from './Names';
import { SignUpPage } from './SignUp';
import { userWithDefault } from '../types/user';
import { AdminAddMember } from './AdminAddMember';
import { AdminCSV } from './AdminCSV';
import { AdminMail } from './AdminMail';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export type Page =
  | 'LoginPage'
  | 'SignUpPage'
  | 'MyPage'
  | 'Names'
  | 'Board'
  | 'AdminAddMember'
  | 'AdminCSV'
  | 'AdminMail';

export const App = memoNamed('App', () => {
  const [page, setPage] = useState<Page>('LoginPage');
  const [isAdmin, setIsAdminTrue, setIsAdminFalse] = useBooleanState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user === null) {
        setIsAdminFalse();
        setPage((page) =>
          page === 'LoginPage' || page === 'SignUpPage' ? page : 'LoginPage'
        );
        return;
      }
      const db = firebase.firestore();
      const uid = firebase.auth().currentUser?.uid;
      db.collection('Users')
        .where('userID', '==', uid)
        .get()
        .then((snapshot) => {
          if (snapshot.size !== 1) return;
          if (userWithDefault(snapshot.docs[0].data()).isAdmin) {
            setIsAdminTrue();
          }
          setPage((page) =>
            page === 'LoginPage' || page === 'SignUpPage' ? 'MyPage' : page
          );
        })
        .catch((error) => {
          console.error(error);
        });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsAdminFalse, setIsAdminTrue]);

  return page === 'LoginPage' ? (
    <LoginPage turnOnIsAdminFlag={setIsAdminTrue} goToPage={setPage} />
  ) : page === 'SignUpPage' ? (
    <SignUpPage turnOnIsAdminFlag={setIsAdminTrue} goToPage={setPage} />
  ) : (
    <div>
      <Header
        isAdmin={isAdmin}
        logout={setIsAdminFalse}
        page={page}
        goToPage={setPage}
      />
      <br />
      <br />
      <br />
      {page === 'MyPage' ? (
        <MyPage gotoPage={setPage} />
      ) : page === 'Names' ? (
        <Names isAdmin={isAdmin} />
      ) : page === 'Board' ? (
        <Board isAdmin={isAdmin} />
      ) : page === 'AdminAddMember' && isAdmin ? (
        <AdminAddMember />
      ) : page === 'AdminCSV' && isAdmin ? (
        <AdminCSV />
      ) : page === 'AdminMail' && isAdmin ? (
        <AdminMail />
      ) : undefined}
    </div>
  );
});
